import axios from '@axios'

export default {
  namespaced: true,

  state: {},
  getters: {},
  mutations: {},

  actions: {
    fetchList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('alerts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    deleteAlert(ctx, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`alerts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    importFile(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.post(`devicesImportExcel`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }

  },
}
